<div class="card vendas-regiao-card p-4 mb-4">
  <h5 class="card-title">Obras por Região</h5>

  <div class="filtros filtros-responsive mb-4">
    <div class="filtro-item">
      <app-filtro-responsavel
        [responsavel]="responsavel"
        [(filtroResponsavel)]="selectedUsuario"
        (responsavelIdChange)="onResponsavelIdChange($event)"
        (responsavelLimpo)="onResponsavelIdChange(0)"
        (responsaveisChange)="onResponsaveisRecebidos($event)"
      ></app-filtro-responsavel>
    </div>

    <div class="filtro-item">
      <app-filtro-estado-cidade
        (regiaoChange)="onRegiaoChange($event)"
        (estadoChange)="onEstadoChange($event)"
        (cidadesChange)="onCidadesChange($event)"
        (filtroAtualizado)="buscarVendasRegiao()"
      ></app-filtro-estado-cidade>
    </div>

    <button type="button" class="btn btn-dark" (click)="exportExcel()" [disabled]="desabilitarExportar">
      <img
        src="{{
          BASE_IMG_URL
        }}assets/agenda-tarefas/download.svg"
        width="20"
        height="20"
        alt=""
      />
      EXPORTAR
    </button>
  </div>

  <div class="view-switch mb-4 d-flex justify-content-between">
    <div class="d-flex filtros-regiao">
      <app-filtro-tipo-obra
        (tiposSelecionadosChange)="onTiposSelecionadosChange($event)"
      ></app-filtro-tipo-obra>

      <app-filtro-periodo
        [(intervaloSelecionado)]="selectedPeriodo"
        [config]="config"
        (intervaloSelecionadoChange)="onPeriodoSelecionadoChange($event)"
      ></app-filtro-periodo>
    </div>
  </div>

  @if (arrVendas.length >0) {
  <div class="grafico-apex row align-items-center justify-content-center">
    <div class="col-md-7">
      <apx-chart
        [series]="chartSeries"
        [chart]="chartOptions.chart"
        [xaxis]="chartOptions.xaxis"
        [colors]="chartOptions.colors"
        [plotOptions]="chartOptions.plotOptions"
        [dataLabels]="chartOptions.dataLabels"
        [tooltip]="chartOptions.tooltip"
      ></apx-chart>
    </div>
  </div>
  } @else {
  <div class="no-results">Não há resultados para os filtros selecionados.</div>
  }
</div>
